import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideHead } from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import { dashboardPagesMenu } from '../../../menu';
import Icon from '../../../components/icon/Icon';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const menuItems = Object.values(dashboardPagesMenu);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<div className='px-3 py-4 d-flex flex-column gap-4'>
					<div>
						<p className='mb-1 text-uppercase small text-muted fw-semibold'>Navigazione</p>
						<h6 className='mb-0 fw-bold text-dark'>Menu principale</h6>
					</div>
					<nav className='d-flex flex-column gap-2'>
						{menuItems.map((item) => (
							<NavLink key={item.id} to={`../${item.path}`} className='text-decoration-none'>
								{({ isActive }) => (
									<div
										className={classNames(
											'd-flex align-items-center gap-3 px-3 py-2 rounded-3 transition-all border border-0 shadow-sm-sm aside-link-minimal',
											{
												'bg-primary text-white shadow-sm': isActive,
												'bg-white text-primary': !isActive,
											},
										)}
										style={{ padding: '0.65rem 0.95rem', borderRadius: '0.85rem', transition: 'all 0.15s ease' }}>
										<span
											className={classNames(
												'd-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0',
												{
													'bg-white text-primary': isActive,
													'bg-primary bg-opacity-10 text-primary': !isActive,
												},
											)}
											style={{ width: 34, height: 34 }}>
											<Icon icon={item.icon || 'Circle'} size='md' />
										</span>
										<div className='flex-grow-1'>
											<span className={classNames('fw-semibold', { 'text-white': isActive, 'text-primary': !isActive })}>
												{item.text}
											</span>
										</div>
									</div>
								)}
							</NavLink>
						))}
					</nav>
				</div>
			</AsideBody>
		</Aside>
	);
};

export default DefaultAside;
